export const getFString = (value: number | string): string => {
    return `${value} °F`;
};
